__turbopack_context__.v({
  "bonusButton": "RatingSummary-module-scss-module__AavlTG__bonusButton",
  "bonusIcon": "RatingSummary-module-scss-module__AavlTG__bonusIcon",
  "bonusesContent": "RatingSummary-module-scss-module__AavlTG__bonusesContent",
  "bonusesLoader": "RatingSummary-module-scss-module__AavlTG__bonusesLoader",
  "bonusesModal": "RatingSummary-module-scss-module__AavlTG__bonusesModal",
  "criteria": "RatingSummary-module-scss-module__AavlTG__criteria",
  "ratingBarRow": "RatingSummary-module-scss-module__AavlTG__ratingBarRow",
  "ratingBarStar": "RatingSummary-module-scss-module__AavlTG__ratingBarStar",
  "ratingBars": "RatingSummary-module-scss-module__AavlTG__ratingBars",
  "ratingHeadline": "RatingSummary-module-scss-module__AavlTG__ratingHeadline",
  "ratingStars": "RatingSummary-module-scss-module__AavlTG__ratingStars",
  "ratingTotal": "RatingSummary-module-scss-module__AavlTG__ratingTotal",
  "ratingValue": "RatingSummary-module-scss-module__AavlTG__ratingValue",
  "reviewsBody": "RatingSummary-module-scss-module__AavlTG__reviewsBody",
  "reviewsCard": "RatingSummary-module-scss-module__AavlTG__reviewsCard",
  "reviewsCardUnavailable": "RatingSummary-module-scss-module__AavlTG__reviewsCardUnavailable",
});
